/**
 * @ngdoc function
 * @name lmApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the lmApp
 */
lmApp.controller('ContactsController', [function () {

  }]);
